export const PROJECTS_QUERY_CONTEXT_PREFIX = 'ProjectsQueryContextProvider';
